import { render } from "./LPPagination.vue?vue&type=template&id=b8d6e126&scoped=true"
import script from "./LPPagination.vue?vue&type=script&lang=js"
export * from "./LPPagination.vue?vue&type=script&lang=js"

import "./LPPagination.vue?vue&type=style&index=0&id=b8d6e126&lang=scss"
import "./LPPagination.vue?vue&type=style&index=1&id=b8d6e126&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d6e126"]])

export default __exports__